export const SATURATION_BORDER = '1.5px solid var(--vg-colors-gray-200)';
export const SATURATION_BORDER_RADIUS = 'var(--vg-radii-base)';
export const SATURATION_HEIGHT = 96;
export const COLOR_DISPLAY_WIDTH = 64;
